import React, { useRef } from 'react';
import Spacing from '../Spacing';
import { Drawer } from 'vaul';

export default function ViewDocflowDetailsModal(props) {
  const {
    details = "",
    activeModal = false,
    setActiveModal = () => {},
    previousScrollPosition = 0,
  } = props;
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Patient Details</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">

              <div className="docpro_modal" style={{ position: 'unset' }}>
                <div className="docpro_signout_wrap">
                  <div className="docpro_signout">
                    <h2 className="docpro_fs_24 docpro_mb_0">Template Instructions</h2>
                    <Spacing lg="10" sm="10" />

                    <div className='w-full'>
                      <p className="docpro_fs_16"
                        style={{
                          border: "1px solid var(--border)",
                          padding: "10px",
                          borderRadius: "6px",
                          backgroundColor: "#fff",
                          minHeight: "80vh",
                          whiteSpace: "pre-wrap"
                        }}
                      >
                        {details}
                      </p>
                    </div>
                  </div>

                  <div className="docpro_invoice_btns docpro_hide_print">
                    <button
                      type='button'
                      className="docpro_invoice_btn docpro_color3 close_button"
                      onClick={() => handleDrawerClose()}
                    >
                      <span className="docpro_btn_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                      </span>
                      <span className="docpro_btn_text">Close</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
